import React from 'react'

function ErrorScreen() {
    return (
        <>
            <div className='content-body'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12' style={{padding :'25px'}}>
                            <img src="../assets/img/underMantenance.gif" style={{height:'90%', borderRadius:20}} className='img-responsive center-block d-block mx-auto' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ErrorScreen